import { render } from "./oemItems.vue?vue&type=template&id=4d359a19&scoped=true"
import script from "./oemItems.vue?vue&type=script&lang=js"
export * from "./oemItems.vue?vue&type=script&lang=js"

import "./oemItems.vue?vue&type=style&index=0&id=4d359a19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d359a19"]])

export default __exports__